import { render } from "./VendorRanking.vue?vue&type=template&id=710f2845&scoped=true"
import script from "./VendorRanking.vue?vue&type=script&lang=js"
export * from "./VendorRanking.vue?vue&type=script&lang=js"

import "./VendorRanking.vue?vue&type=style&index=0&id=710f2845&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710f2845"]])

export default __exports__